import { ChangeDetectionStrategy, Component, EventEmitter, HostListener, Input, Output } from '@angular/core';
import { DefaultTo } from '@panaya/utils';

const DefaultChecked = false;
const DefaultDisabled = false;
const DefaultIndeterminate = false;
const DefaultAriaLabel = '';

@Component({
    selector: 'p-checkbox',
    templateUrl: './p-checkbox.component.html',
    styleUrls: ['./p-checkbox.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class PCheckboxComponent {
    @Input() public label?: string;
    @Input() @DefaultTo(DefaultAriaLabel) public ariaLabel!: string;
    @Input() @DefaultTo(DefaultChecked) public checked!: boolean;
    @Input() @DefaultTo(DefaultDisabled) public disabled!: boolean;
    @Input() @DefaultTo(DefaultIndeterminate) public indeterminate!: boolean;

    @Output() public readonly checkedChange = new EventEmitter<boolean>();

    public onValueChanged(event: Event): void {
        this.checkedChange.emit((<HTMLInputElement>event.target).checked);
    }

    @HostListener('click', ['$event'])
    public onCheckboxClick(event: Event): void {
        event.stopPropagation();
    }
}
